import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';             //全局引入element
import 'element-ui/lib/theme-chalk/index.css';    //全局引入element的样式
import router from './router'
import VueI18n from 'vue-i18n'
import cnlang from './lang/cn.js'
import jplang from './lang/jp.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import "swiper/dist/css/swiper.css";




Vue.config.productionTip = false

Vue.use(ElementUI);     //全局注入element
Vue.use(VueI18n);
Vue.use(VueAwesomeSwiper);

const i18n = new VueI18n({
  locale: 'jp', // 默认语言
  messages: {
  	'cn': cnlang,
	'jp': jplang
  }
})

new Vue({
	router,
	i18n,
  render: h => h(App),
}).$mount('#app')
